type ChangeValueType = number | string | undefined | null;

export const format = {
  price: (value: ChangeValueType) =>
    String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
  percent: (value: ChangeValueType) => `${String(value)}%`,
};

export default format;
